import { useParams } from 'react-router-dom'
import RegionDashboard from '../components/admin/RegionDashboard'

export default function RegionPage() {
  const { regionId } = useParams()
  return <RegionDashboard regionId={regionId} />
}
